module.exports = __webpack_public_path__ + "static/media/karl_straub_mood.8d8ca2c2.jpg";